"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3260],{

/***/ 79835:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"https://images-qa.forumm.to/2810/_next/static/media/header-background.10993a0a.png","height":480,"width":1924,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACBAMAAACXuoDeAAAAGFBMVEVq48Zn2NFjy9tgwOZYrOtJjeg8ceYwVuSCP/gQAAAAEklEQVR42mMoCzESYCgLMRIAAAvWAhnMYywNAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":2});

/***/ }),

/***/ 623:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

const LoadingBar = ()=>{
    const shimmerStyle = {
        backgroundSize: "200% 100%",
        animation: "shimmer 1.5s infinite"
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "w-full h-2 bg-blue-100 overflow-hidden relative",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "w-full h-full absolute transform translate-x-0 bg-gradient-to-r from-transparent via-blue-500 to-transparent",
            style: shimmerStyle
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LoadingBar);


/***/ }),

/***/ 69341:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _public_images_default_thumbnail_png__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96963);
/* harmony import */ var _libs_useAuth__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32462);
/* harmony import */ var _base_Box__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51773);
/* harmony import */ var _components_landing_Media__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52987);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67294);
/* harmony import */ var _components_inputs_Button__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(11390);
/* harmony import */ var _libs_Utility_util__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(53510);








const EventsView = (param)=>{
    let { events , types , title , currency , justify  } = param;
    const { profile , isOrganizer , isAdmin , canEditEvent  } = (0,_libs_useAuth__WEBPACK_IMPORTED_MODULE_2__/* .useAuth */ .aC)();
    const userId = profile === null || profile === void 0 ? void 0 : profile.userId;
    const [viewAll, setViewAll] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(false);
    const isSpeaker = (event)=>{
        var ref;
        if (!event || !profile) return false;
        return !!((ref = event.speakers) === null || ref === void 0 ? void 0 : ref.find((f)=>{
            return f.email === (profile === null || profile === void 0 ? void 0 : profile.email);
        }));
    };
    // TODO: Define types correctly
    const renderEventCard = (e)=>{
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11;
        if (!e) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
        var ref12, ref13;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_landing_Media__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            eventId: e.eventId,
            url: (e === null || e === void 0 ? void 0 : (ref = e.event) === null || ref === void 0 ? void 0 : ref.eventType) === "FUNDRAISER" ? "/donation/".concat(e.event.donationUrl) : "/event/".concat(e.eventId),
            type: e.event.eventType,
            title: (ref1 = e.event) === null || ref1 === void 0 ? void 0 : ref1.title,
            description: (ref2 = e.event) === null || ref2 === void 0 ? void 0 : ref2.shortDescription,
            image: (ref12 = (ref3 = e.event) === null || ref3 === void 0 ? void 0 : ref3.bannerImage) !== null && ref12 !== void 0 ? ref12 : _public_images_default_thumbnail_png__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z,
            banner: (ref13 = (ref4 = e.event) === null || ref4 === void 0 ? void 0 : ref4.thumbnailImage) !== null && ref13 !== void 0 ? ref13 : _public_images_default_thumbnail_png__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z,
            organization: e === null || e === void 0 ? void 0 : (ref5 = e.event) === null || ref5 === void 0 ? void 0 : ref5.organizationName,
            startTime: (ref6 = e.event) === null || ref6 === void 0 ? void 0 : ref6.startDateTime,
            endTime: (ref7 = e.event) === null || ref7 === void 0 ? void 0 : ref7.endDateTime,
            canEdit: canEditEvent(e),
            isSpeaker: isSpeaker(e),
            isPublished: e.isPublished,
            attendees: e.eventId === "31fffe01-557f-4c3c-a7f3-cb1ec9772277" ? "306" : (ref8 = e.attendees) === null || ref8 === void 0 ? void 0 : ref8.length,
            donors: (ref9 = e.fundraising) === null || ref9 === void 0 ? void 0 : ref9.donors,
            goal: (ref10 = e.fundraising) === null || ref10 === void 0 ? void 0 : ref10.goal,
            raised: (ref11 = e.fundraising) === null || ref11 === void 0 ? void 0 : ref11.raised,
            currency: currency !== null && currency !== void 0 ? currency : "GBP"
        }, e.eventId);
    };
    // TODO: Define types correctly
    const renderEvents = (data)=>{
        // TODO: Define types correctly
        return data.sort((a, b)=>(0,_libs_Utility_util__WEBPACK_IMPORTED_MODULE_7__/* .isEventAfter */ .r3)(a, b)).map((e)=>{
            var ref, ref1;
            if (((ref = e.event) === null || ref === void 0 ? void 0 : ref.eventType) == null) {
                return null;
            }
            if (!types.includes((ref1 = e.event) === null || ref1 === void 0 ? void 0 : ref1.eventType)) {
                return null;
            }
            if (title.length > 0 && !e.event.title.toLowerCase().includes(title.toLowerCase())) {
                return null;
            }
            return renderEventCard(e);
        });
    };
    const justifyClass = justify === "center" ? "" : " sm:justify-start sm:items-start";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_base_Box__WEBPACK_IMPORTED_MODULE_3__["default"], {
        className: "flex sm:-mx-4 md:w-[110%] max-w-[1530px] flex-wrap justify-center items-center ".concat(justifyClass),
        children: [
            viewAll ? renderEvents(events) : renderEvents(events === null || events === void 0 ? void 0 : events.slice(0, 8)),
            events.length <= 8 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}) : !viewAll && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_base_Box__WEBPACK_IMPORTED_MODULE_3__["default"], {
                className: "w-full justify-center flex mt-3",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_Button__WEBPACK_IMPORTED_MODULE_6__/* .Button */ .z, {
                    className: "sm:min-w-[15rem] text-xs sm:text-sm",
                    title: "View All",
                    type: "primary",
                    textColor: "white",
                    onClick: ()=>setViewAll(true)
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (EventsView);


/***/ }),

/***/ 68758:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ GET_EVENTS_BY_COMPANY_OVERVIEWS; }
/* harmony export */ });
/* harmony import */ var _graphql_generated__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66703);

const GET_EVENTS_BY_COMPANY_OVERVIEWS = (0,_graphql_generated__WEBPACK_IMPORTED_MODULE_0__/* .graphql */ .B)("\n  query GetEventsByCompanyOverviews($company: String!) {\n    getEventsByCompany(company: $company) {\n      ...EventOverview\n    }\n  }\n");


/***/ }),

/***/ 99261:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "kM": function() { return /* binding */ GET_PREMIUM_EVENTS_BY_ORGANISATION_URL; },
/* harmony export */   "mx": function() { return /* binding */ GET_PREMIUM_EVENTS_BY_ORGANISATION; }
/* harmony export */ });
/* unused harmony export GET_PREMIUM_EVENTS_FOR_USER_ID */
/* harmony import */ var _graphql_generated__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66703);

const GET_PREMIUM_EVENTS_BY_ORGANISATION = (0,_graphql_generated__WEBPACK_IMPORTED_MODULE_0__/* .graphql */ .B)("\n  query GetPremiumEventsByOrganisationOverviews {\n    getPremiumEventsByOrganisation {\n      ...EventOverview\n    }\n  }\n");
const GET_PREMIUM_EVENTS_BY_ORGANISATION_URL = (0,_graphql_generated__WEBPACK_IMPORTED_MODULE_0__/* .graphql */ .B)("\n  query GetPremiumEventsByOrganisationUrlOverviews($url: String!) {\n    getPremiumEventsByOrganisationUrl(url: $url) {\n      ...EventOverview\n    }\n  }\n");
const GET_PREMIUM_EVENTS_FOR_USER_ID = (0,_graphql_generated__WEBPACK_IMPORTED_MODULE_0__/* .graphql */ .B)("\n  query GetPremiumEventsForUserId {\n    getPremiumEventsForUserId {\n      ...EventOverview\n    }\n  }\n");


/***/ }),

/***/ 41826:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ UPDATE_ORGANISATION; }
/* harmony export */ });
/* harmony import */ var _graphql_generated__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66703);

const UPDATE_ORGANISATION = (0,_graphql_generated__WEBPACK_IMPORTED_MODULE_0__/* .graphql */ .B)("\n  mutation updateOrganisation(\n    $name: String!\n    $organisationType: String\n    $mainColour: String\n    $bannerImage: String\n    $logoImage: String\n    $currency: String\n    $percentage: Float\n    $headerTextOne: String\n    $headerTextTwo: String\n    $dashboardPopupDoNotShowAgain: Boolean\n  ) {\n    updateOrganisation(\n      name: $name\n      organisationType: $organisationType\n      mainColour: $mainColour\n      bannerImage: $bannerImage\n      logoImage: $logoImage\n      currency: $currency\n      percentage: $percentage\n      headerTextOne: $headerTextOne\n      headerTextTwo: $headerTextTwo\n      dashboardPopupDoNotShowAgain: $dashboardPopupDoNotShowAgain\n    ) {\n      success\n    }\n  }\n");


/***/ }),

/***/ 25875:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ GoogleAds; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_base_Box__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51773);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);



const ADS_ENABLED = "false";
const DEBUG_MODE = false;
const GoogleAds = (param)=>{
    let { type , show =true , className =""  } = param;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        try {
            if (!show) return;
            if (true) {
                if (!window.adsbygoogle) window.adsbygoogle = [];
                window.adsbygoogle.push({});
                console.log({
                    ads: window.adsbygoogle
                });
            } else {}
        } catch (err) {
            if (DEBUG_MODE) console.log(err);
            else console.log("Ad Error Suppressed.");
        }
    }, []);
    if ((ADS_ENABLED === null || ADS_ENABLED === void 0 ? void 0 : ADS_ENABLED.toLowerCase()) !== "true" || !show) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    if (type === "square") return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
        className: "".concat(className),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ins", {
            className: "adsbygoogle gad_sign_up_page",
            style: {
                // display: 'inline-block',
                display: "block",
                // height: '90px',
                // width: '100%',
                outline: DEBUG_MODE ? "1px solid red" : "none"
            },
            "data-ad-client": "ca-pub-3643756915754911",
            "data-ad-slot": "9657998552",
            "data-ad-format": "auto",
            "data-full-width-responsive": "true"
        })
    });
    if (type === "vertical") return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
        className: "".concat(className),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ins", {
            className: "adsbygoogle gad_sign_up_page",
            style: {
                display: "inline-block",
                height: "100%",
                width: "300px",
                outline: DEBUG_MODE ? "1px solid red" : "none"
            },
            "data-ad-client": "ca-pub-3643756915754911",
            "data-ad-slot": "3092590200",
            "data-ad-format": "auto",
            "data-full-width-responsive": "true"
        })
    });
    if (type === "horizontal") return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
        className: "".concat(className),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ins", {
            className: "adsbygoogle gad_sign_up_page",
            style: {
                display: "inline-block",
                height: "90px",
                width: "100%",
                outline: DEBUG_MODE ? "1px solid red" : "none"
            },
            "data-ad-client": "ca-pub-3643756915754911",
            "data-ad-slot": "2515404500",
            "data-ad-format": "inline",
            "data-full-width-responsive": "false"
        })
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
};


/***/ }),

/***/ 49981:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RC": function() { return /* binding */ getOrganisationConfig; },
/* harmony export */   "ce": function() { return /* binding */ CONFIG_OPTIONS; },
/* harmony export */   "rS": function() { return /* binding */ getRegistrationConfig; }
/* harmony export */ });
/* harmony import */ var _graphql_generated_graphql__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68240);

var CONFIG_OPTIONS;
(function(CONFIG_OPTIONS) {
    CONFIG_OPTIONS[CONFIG_OPTIONS["SHOW_FULL_REGISTRATION_OPTIONS"] = 0] = "SHOW_FULL_REGISTRATION_OPTIONS";
    CONFIG_OPTIONS[CONFIG_OPTIONS["SHOW_ACCOUNT_PROMPT"] = 1] = "SHOW_ACCOUNT_PROMPT";
    CONFIG_OPTIONS[CONFIG_OPTIONS["SHOW_VISIBLE_REGISTRATION_OPT_IN"] = 2] = "SHOW_VISIBLE_REGISTRATION_OPT_IN";
    CONFIG_OPTIONS[CONFIG_OPTIONS["SHOW_ATTENDEE_BOX"] = 3] = "SHOW_ATTENDEE_BOX";
    CONFIG_OPTIONS[CONFIG_OPTIONS["ALLOW_DIRECT_DEBIT"] = 4] = "ALLOW_DIRECT_DEBIT";
    CONFIG_OPTIONS[CONFIG_OPTIONS["SHOW_GOOGLE_ADS"] = 5] = "SHOW_GOOGLE_ADS";
    CONFIG_OPTIONS[CONFIG_OPTIONS["SHOW_QUICK_REGISTRATION_OPTIONS"] = 6] = "SHOW_QUICK_REGISTRATION_OPTIONS";
})(CONFIG_OPTIONS || (CONFIG_OPTIONS = {}));
// NOTE: Temporary config options
const getRegistrationConfig = (opt, event)=>{
    var ref, ref1, ref2;
    // console.log(`[RegistrationConfig]: `, { opt, event })
    if (!event) return true;
    const isInPerson = ((ref = event.event) === null || ref === void 0 ? void 0 : ref.eventType) === _graphql_generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .EventType.InPerson */ .tw.InPerson;
    var ref3;
    // const isOnline = event.event?.eventType === EventType.Online
    const orgName = (ref3 = event === null || event === void 0 ? void 0 : (ref1 = event.event) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.organizationName) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase()) !== null && ref3 !== void 0 ? ref3 : "";
    switch(opt){
        case CONFIG_OPTIONS.SHOW_ACCOUNT_PROMPT:
            if (orgName.includes("sussex")) return false;
            if (orgName.includes("448 studio")) return false;
            break;
        case CONFIG_OPTIONS.SHOW_FULL_REGISTRATION_OPTIONS:
            if (orgName.includes("sussex")) return false;
            if (orgName.includes("448 studio")) return false;
            break;
        case CONFIG_OPTIONS.SHOW_VISIBLE_REGISTRATION_OPT_IN:
            if (orgName.includes("sussex")) return true;
            if (orgName.includes("forumm")) return true;
            // if (orgName.includes('imaginary friends')) return true
            if (event.eventId === "16caaaed-dc0d-44d7-936d-0a590dfef429") return true;
            return false;
        case CONFIG_OPTIONS.ALLOW_DIRECT_DEBIT:
            if (orgName.includes("sussex")) return true;
            if (orgName.includes("448 studio")) return true;
            if (orgName.includes("forumm")) return true;
            return false;
        case CONFIG_OPTIONS.SHOW_ATTENDEE_BOX:
            if (orgName.includes("sussex")) return true;
            // if (orgName.includes('imaginary friends')) return true
            if (orgName.includes("university of glasgow") && isInPerson) return true;
            if (event.eventId === "16caaaed-dc0d-44d7-936d-0a590dfef429") return true;
            if (event.eventId === "e172670e-a062-4f05-9e33-b334a57fff93") return true;
            return false;
        case CONFIG_OPTIONS.SHOW_QUICK_REGISTRATION_OPTIONS:
            if (event.eventId === "236e01cf-bcfb-41e0-94e9-4c173e2e16f4") return false;
            if (event.eventId === "59080128-59d6-4164-a824-0e48b01ef75f") return false;
            return true;
    }
    return true;
};
const getOrganisationConfig = (opt, orgName)=>{
    // console.log(`[OrganisationConfig]: `, { opt, orgName })
    if (!orgName) return true;
    const sanitisedOrgName = orgName.toLowerCase();
    switch(opt){
        case CONFIG_OPTIONS.SHOW_GOOGLE_ADS:
            if (sanitisedOrgName.includes("sussex")) return false;
            return true;
    }
    return true;
};


/***/ }),

/***/ 11734:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ libs_useFileUploader; }
});

// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useMutation.js + 1 modules
var useMutation = __webpack_require__(72742);
// EXTERNAL MODULE: ./graphql/__generated/index.ts + 1 modules
var _generated = __webpack_require__(66703);
;// CONCATENATED MODULE: ./graphql/media/uploadMedia.ts

const UPLOAD_MEDIA = (0,_generated/* graphql */.B)("\n  mutation UploadMedia($input: MediaUploadInput!) {\n    uploadMedia(input: $input) {\n      preSignedUrl\n      uploadedFileUrl\n    }\n  }\n");

// EXTERNAL MODULE: ./node_modules/uuid/dist/esm-browser/v4.js + 3 modules
var v4 = __webpack_require__(57632);
;// CONCATENATED MODULE: ./libs/useFileUploader.ts



const useFileUploader = ()=>{
    const [uploadMedia] = (0,useMutation/* useMutation */.D)(UPLOAD_MEDIA);
    const generateSafeFileName = (name)=>{
        return (0,v4/* default */.Z)();
    };
    const uploadFile = async (file)=>{
        var ref, ref1;
        const response = await uploadMedia({
            variables: {
                input: {
                    contentType: "application/x-www-form-urlencoded",
                    filename: generateSafeFileName(file.name)
                }
            }
        });
        const preSignedUrl = (ref = response.data) === null || ref === void 0 ? void 0 : ref.uploadMedia.preSignedUrl;
        const uploadedFileUrl = (ref1 = response.data) === null || ref1 === void 0 ? void 0 : ref1.uploadMedia.uploadedFileUrl;
        await fetch(preSignedUrl, {
            method: "PUT",
            body: file,
            headers: {
                "Content-Type": file.type
            }
        });
        return uploadedFileUrl !== null && uploadedFileUrl !== void 0 ? uploadedFileUrl : "";
    };
    return uploadFile;
};
/* harmony default export */ var libs_useFileUploader = (useFileUploader);


/***/ }),

/***/ 48332:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ clearLS; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6812);


function useLSFirst(key, query, props) {
    const [localData, setLocalData] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(()=>{
        // Retrieve initial data from local storage
        const storedData = localStorage.getItem(key);
        return storedData ? JSON.parse(storedData) : null;
    });
    const { loading , data: serverData , ...rest } = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)(query, props);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (serverData) {
            // Update local storage when new data is fetched
            localStorage.setItem(key, JSON.stringify(serverData));
            // Sync local data with the server data
            setLocalData(serverData);
        }
    }, [
        serverData,
        key
    ]);
    // Return loading state and localData as a fallback for `data`
    return {
        loading,
        data: localData || serverData,
        ...rest
    };
}
const clearLS = (keys)=>{
    keys.forEach((key)=>localStorage.removeItem(key));
};
/* harmony default export */ __webpack_exports__["Z"] = (useLSFirst);


/***/ }),

/***/ 83260:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ OrganizerLaunchPage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useMutation.js + 1 modules
var useMutation = __webpack_require__(72742);
// EXTERNAL MODULE: ./libs/useAuth.ts + 25 modules
var useAuth = __webpack_require__(32462);
// EXTERNAL MODULE: ./libs/useTheme.ts + 1 modules
var useTheme = __webpack_require__(5779);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./libs/useOrganisationProfile.ts
var useOrganisationProfile = __webpack_require__(19058);
// EXTERNAL MODULE: ./components/inputs/FileInput.tsx + 7 modules
var FileInput = __webpack_require__(89787);
// EXTERNAL MODULE: ./libs/useFileUploader.ts + 1 modules
var useFileUploader = __webpack_require__(11734);
// EXTERNAL MODULE: ./libs/useLSFirst.ts
var useLSFirst = __webpack_require__(48332);
// EXTERNAL MODULE: ./components/inputs/Button.tsx
var Button = __webpack_require__(11390);
// EXTERNAL MODULE: ./components/event/EventsView.tsx
var EventsView = __webpack_require__(69341);
// EXTERNAL MODULE: ./components/base/LoadingBar.tsx
var LoadingBar = __webpack_require__(623);
// EXTERNAL MODULE: ./components/chat/EventChatBox.tsx + 12 modules
var EventChatBox = __webpack_require__(62293);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs + 4 modules
var AnimatePresence = __webpack_require__(65820);
// EXTERNAL MODULE: ./layouts/Wrapper.tsx + 9 modules
var Wrapper = __webpack_require__(44066);
// EXTERNAL MODULE: ./components/base/Box.tsx
var Box = __webpack_require__(51773);
;// CONCATENATED MODULE: ./layouts/DashboardLayout.tsx






const DashboardLayout = (param)=>{
    let { children  } = param;
    const { profile  } = (0,useAuth/* useAuth */.aC)();
    var ref, ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper/* default */.ZP, {
        className: "h-screen",
        wrapperClasses: "flex flex-col flex-1",
        showFooter: false,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
            mode: "wait",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                className: "flex flex-1",
                children: [
                    children,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(EventChatBox/* default */.Z, {
                        showEventPeopleTab: true,
                        showUniversityUsers: true,
                        defaultChatName: (profile === null || profile === void 0 ? void 0 : profile.university) != null || (profile === null || profile === void 0 ? void 0 : profile.company) != null ? "".concat((ref = profile === null || profile === void 0 ? void 0 : profile.university) !== null && ref !== void 0 ? ref : profile === null || profile === void 0 ? void 0 : profile.company, " Chat") : "General Chat",
                        defaultChatId: (profile === null || profile === void 0 ? void 0 : profile.university) != null || (profile === null || profile === void 0 ? void 0 : profile.company) != null ? "".concat((ref1 = profile === null || profile === void 0 ? void 0 : profile.university) !== null && ref1 !== void 0 ? ref1 : profile === null || profile === void 0 ? void 0 : profile.company, "-general") : "general-chat"
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var layouts_DashboardLayout = (DashboardLayout);

// EXTERNAL MODULE: ./components/base/Text.tsx
var Text = __webpack_require__(40517);
// EXTERNAL MODULE: ./node_modules/react-icons/md/index.esm.js
var index_esm = __webpack_require__(5434);
// EXTERNAL MODULE: ./components/base/Modal.tsx
var Modal = __webpack_require__(18860);
// EXTERNAL MODULE: ./node_modules/react-icons/io5/index.esm.js
var io5_index_esm = __webpack_require__(60155);
// EXTERNAL MODULE: ./components/inputs/TextInput.tsx
var TextInput = __webpack_require__(39618);
// EXTERNAL MODULE: ./libs/Utility/util.ts + 3 modules
var util = __webpack_require__(53510);
// EXTERNAL MODULE: ./components/inputs/Form.tsx + 1 modules
var Form = __webpack_require__(52090);
;// CONCATENATED MODULE: ./components/inputs/OrganizationBannerEditPopup.tsx












const OrganizationBannerEditPopup = (param)=>{
    let { onSave , headerTextOne , headerTextTwo  } = param;
    const { theme  } = (0,useTheme/* useTheme */.Fg)();
    // const [form, setForm] = useState<{
    //   title?: string
    //   subtitle: string
    // }>({
    //   title: '',
    //   subtitle: '',
    // })
    const [isOpen, setIsOpen] = (0,react.useState)(false);
    // const handleSave = () => {
    //   const hasTitle =
    //     form.title && form.title.length >= 5 && form.title.length < 200
    //   const hasSubtitle =
    //     form.subtitle && form.subtitle.length >= 5 && form.subtitle.length < 200
    //   if (hasTitle && hasSubtitle) {
    //     onSave(form?.title ?? '', form?.subtitle ?? '')
    //     setIsOpen(false)
    //   }
    // }
    // useEffect(() => {
    //   if (isOpen) {
    //     setForm({
    //       ...form,
    //       title: headerTextOne ?? '',
    //       subtitle: headerTextTwo ?? '',
    //     })
    //   }
    // }, [isOpen])
    const textEditModal = /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
        show: isOpen || false,
        setShow: (val)=>{
            if (setIsOpen) setIsOpen(val);
        },
        className: "p-0",
        version: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* Form */.l, {
            initialFormData: {
                bannerTitle: headerTextOne !== null && headerTextOne !== void 0 ? headerTextOne : "",
                bannerSubtitle: headerTextTwo !== null && headerTextTwo !== void 0 ? headerTextTwo : ""
            },
            onSubmit: async (data)=>{
                try {
                    console.log({
                        data
                    });
                    const { bannerTitle , bannerSubtitle  } = data;
                    onSave(bannerTitle, bannerSubtitle);
                } catch (error) {
                    console.error(error);
                    var _message;
                    return (_message = error.message) !== null && _message !== void 0 ? _message : "Failed to sign in";
                }
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                    className: "sticky top-0 z-10 flex justify-between items-center p-4 rounded-tl-xl rounded-tr-xl",
                    style: {
                        backgroundColor: theme.foregroundColour
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                            className: "flex items-center justify-start",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                className: "text-md font-bold",
                                children: "Configure your organisation heading text"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoClose */.bjh, {
                            className: "w-6 h-6 cursor-pointer",
                            onClick: ()=>setIsOpen(false)
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                    className: "relative p-10 pt-3 pb-6",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* TextInput */.o, {
                                validations: {
                                    minLength: {
                                        value: 5,
                                        message: "The Title must be at least 5 characters"
                                    },
                                    maxLength: {
                                        value: 200,
                                        message: "The Title must be less than 200 characters"
                                    }
                                },
                                label: "Banner Title",
                                placeholder: "Your Banner Title",
                                required: true
                            }, "title_edit_field")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            className: "mb-5",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* TextInput */.o, {
                                validations: {
                                    minLength: {
                                        value: 5,
                                        message: "The Subtitle must be at least 5 characters"
                                    },
                                    maxLength: {
                                        value: 200,
                                        message: "The Subtitle must be less than 200 characters"
                                    }
                                },
                                label: "Banner Subtitle",
                                placeholder: "Your Banner Subtitle",
                                required: true
                            }, "subtitle_edit_field")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                            className: "w-full flex justify-end",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                title: "Save",
                                buttonType: "submit",
                                size: "auto"
                            })
                        })
                    ]
                })
            ]
        })
    });
    const contrastColor = (0,util/* getContrastColor */.RN)(theme.highlightColour);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
        onClick: ()=>setIsOpen(true),
        className: "absolute top-5 -right-5 sm:top-0 sm:right-0 !h-[33px] !w-[33px] inline-block rounded-full items-center cursor-pointer text-white ml-2 transform",
        style: {
            backgroundColor: theme.highlightColour
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MdEdit */.zmo, {
                className: "absolute top-[8px] left-[9px] h-4 w-4 inline-block hover:animate-heartbeat",
                style: {
                    color: contrastColor
                }
            }),
            textEditModal
        ]
    });
};
/* harmony default export */ var inputs_OrganizationBannerEditPopup = (OrganizationBannerEditPopup);

;// CONCATENATED MODULE: ./components/dashboard/FilterButton.tsx





function FilterButton(param) {
    let { buttonType , setTitle , title , types , setTypes  } = param;
    const { theme  } = (0,useTheme/* useTheme */.Fg)();
    const handleTypes = ()=>{
        if (types.includes(buttonType)) {
            let filteredArray = types.filter((value)=>value !== buttonType);
            if (filteredArray.length === 0) {
                return setTypes([
                    "ONLINE"
                ]);
            }
            setTypes(filteredArray);
        }
        if (!types.includes(buttonType)) setTypes([
            ...types,
            buttonType
        ]);
    };
    const handlePress = ()=>{
        if (buttonType === "IN_PERSON") {
            setTitle("In-person");
        }
        if (buttonType === "FUNDRAISER") {
            setTitle("Donations");
        }
        if (buttonType === "ONLINE") {
            setTitle("Online");
        }
        handleTypes();
    };
    // steal this
    const contrastColor = (0,util/* getContrastColor */.RN)(theme.highlightColour);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
        onClick: handlePress,
        className: "rounded-full px-1 sm:px-2 py-[5px] cursor-pointer flex items-center gap-1 hover:animate-heartbeat",
        style: {
            backgroundColor: types.includes(buttonType) ? theme.highlightColour : "white",
            border: types.includes(buttonType) ? "none" : "1px solid #c6c6d0"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoCheckmark */.jI1, {
                style: {
                    color: types.includes(buttonType) ? contrastColor : "#c6c6d0"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "text-[13px] text-xs sm:text-sm px-2",
                style: {
                    color: types.includes(buttonType) ? contrastColor : "#c6c6d0"
                },
                children: title
            })
        ]
    });
}
/* harmony default export */ var dashboard_FilterButton = (FilterButton);

;// CONCATENATED MODULE: ./components/dashboard/SearchEvent.tsx





function SearchEvent(param) {
    let { searchTerm , setSearchTerm  } = param;
    const { theme  } = (0,useTheme/* useTheme */.Fg)();
    const [value, setValue] = (0,react.useState)(searchTerm);
    const isDarkTheme = theme.type === "DARK";
    (0,react.useEffect)(()=>{
        if (value.length >= 3) {
            setSearchTerm(value);
        }
        if (value.length === 0) {
            setSearchTerm(value);
        }
    }, [
        setSearchTerm,
        value
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
        className: "flex p-1 border ".concat(isDarkTheme ? "border border-panel-gray" : "border border-forumm-menu-border", " rounded-3xl"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                type: "text",
                placeholder: "Find your event",
                className: "ml-4 outline-none w-full text-xs sm:text-sm hover:animate-heartbeat",
                value: value,
                onChange: (e)=>setValue(e.target.value),
                style: {
                    backgroundColor: "transparent"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                title: "Search",
                className: "text-xs sm:text-sm",
                onClick: ()=>setSearchTerm(value)
            })
        ]
    });
}
/* harmony default export */ var dashboard_SearchEvent = (SearchEvent);

// EXTERNAL MODULE: ./graphql/organisation/updateOrganisation.ts
var organisation_updateOrganisation = __webpack_require__(41826);
;// CONCATENATED MODULE: ./components/dashboard/StylingModal.tsx











const StylingModal = (param)=>{
    let { organisationData  } = param;
    const { push  } = (0,next_router.useRouter)();
    const { theme  } = (0,useTheme/* useTheme */.Fg)();
    const [isOpen, setIsOpen] = (0,react.useState)(false);
    const [doNotShowAgain, setDoNotShowAgain] = (0,react.useState)(false);
    const [updateOrganisation] = (0,useMutation/* useMutation */.D)(organisation_updateOrganisation/* UPDATE_ORGANISATION */.$);
    (0,react.useEffect)(()=>{
        if (organisationData === null || organisationData === void 0 ? void 0 : organisationData.name) {
            const doNotShowAgain = organisationData === null || organisationData === void 0 ? void 0 : organisationData.dashboardPopupDoNotShowAgain;
            if (doNotShowAgain) return;
            const hasCustomized = !!((organisationData === null || organisationData === void 0 ? void 0 : organisationData.bannerImage) && (organisationData === null || organisationData === void 0 ? void 0 : organisationData.logoImage) && (organisationData === null || organisationData === void 0 ? void 0 : organisationData.mainColour));
            if (!hasCustomized) {
                setIsOpen(true);
            }
        }
    }, [
        organisationData
    ]);
    const handleSave = async ()=>{
        if (organisationData === null || organisationData === void 0 ? void 0 : organisationData.name) {
            updateOrganisation({
                variables: {
                    name: organisationData.name,
                    dashboardPopupDoNotShowAgain: doNotShowAgain
                }
            });
            setIsOpen(false);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
        show: isOpen || false,
        setShow: (val)=>{
            if (setIsOpen) setIsOpen(val);
        },
        title: "Modal Title",
        className: "p-0",
        version: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
            className: "overflow-auto scrollbar-hide rounded rounded-xl ".concat(theme.type === "DARK" ? "bg-midnight-dark" : "bg-white"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                    className: "sticky top-0 z-10 flex justify-between items-center p-4 rounded-tl-xl rounded-tr-xl",
                    style: {
                        backgroundColor: theme.foregroundColour
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                            className: "flex items-center justify-start",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                className: "text-md font-bold",
                                children: "\uD83C\uDFA8 Enhance Your Brand Identity Now"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoClose */.bjh, {
                            className: "w-6 h-6 cursor-pointer",
                            onClick: ()=>{
                                handleSave();
                                setIsOpen(false);
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                    className: "relative p-10",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                            className: "mb-5",
                            children: [
                                "Let",
                                "'",
                                "s Add Some Color to Your World!"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                            className: "mb-5",
                            children: [
                                "We",
                                "'",
                                "ve noticed that your organisation",
                                "'",
                                "s dashboard is still in its default attire. It",
                                "'",
                                "s time to dress it up! Customize your dashboard now to make it truly yours and resonate with your brand",
                                "'",
                                "s unique identity."
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                            className: "mb-5",
                            children: [
                                "Just a few clicks and you",
                                "'",
                                "ll transform your dashboard from generic to iconic."
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                            className: "w-full flex items-center justify-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                title: "Complete your brand identity now!",
                                type: "primary",
                                size: "auto",
                                onClick: ()=>{
                                    handleSave();
                                    push("/organisation-settings");
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                            className: "mt-8",
                            children: [
                                "Let your organisation",
                                "'",
                                "s character shine through every aspect of your dashboard. This is more than customization; it",
                                "'",
                                "s about creating an experience that aligns with your vision and engages your audience."
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                            className: "text-sm mb-1 mt-8",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    type: "checkbox",
                                    checked: doNotShowAgain,
                                    onChange: ()=>setDoNotShowAgain(!doNotShowAgain),
                                    className: "mr-2 pt-1"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "font-bold cursor-pointer",
                                    onClick: ()=>setDoNotShowAgain(!doNotShowAgain),
                                    children: "Do not show again"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                            className: "w-full flex justify-end",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                title: "Skip",
                                type: "secondary",
                                size: "auto",
                                onClick: handleSave
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var dashboard_StylingModal = (StylingModal);

// EXTERNAL MODULE: ./public/header-background.png
var header_background = __webpack_require__(79835);
// EXTERNAL MODULE: ./components/page/FooterUnauthenticated.tsx + 2 modules
var FooterUnauthenticated = __webpack_require__(79633);
// EXTERNAL MODULE: ./graphql/__generated/index.ts + 1 modules
var _generated = __webpack_require__(66703);
;// CONCATENATED MODULE: ./graphql/events/getMyEventOverviews.ts

const GET_MY_EVENT_OVERVIEWS = (0,_generated/* graphql */.B)("\n  query GetMyEventOverviews {\n    getMyEvents {\n      ...EventOverview\n    }\n  }\n");

// EXTERNAL MODULE: ./graphql/events/getEventsByCompanyOverviews.ts
var getEventsByCompanyOverviews = __webpack_require__(68758);
;// CONCATENATED MODULE: ./graphql/events/getAllEventOverviews.ts

const GET_ALL_EVENT_OVERVIEWS = (0,_generated/* graphql */.B)("\n  query GetAllEventOverviews {\n    getAllPublicEvents {\n      ...EventOverview\n    }\n  }\n");

;// CONCATENATED MODULE: ./graphql/events/getPastEvents.ts

const GET_PAST_EVENTS = (0,_generated/* graphql */.B)("\n  query GetPastEvents {\n    getPastEvents {\n      eventId\n      organizerId\n      isPublished\n      isComplete\n      event {\n        eventType\n        bannerImage\n        description\n        eventMainColour\n        eventBackgroundColour\n        eventTextColour\n        endDateTime\n        shortDescription\n        startDateTime\n        entryDateTime\n        title\n        organizationName\n        thumbnailImage\n        donationUrl\n        currency\n      }\n      attendees {\n        name\n      }\n      fundraising {\n        goal\n        donors\n        raised\n      }\n      speakers {\n        email\n      }\n    }\n  }\n");

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./libs/GoogleAdsManager.tsx
var GoogleAdsManager = __webpack_require__(25875);
// EXTERNAL MODULE: ./libs/Utility/register.util.ts
var register_util = __webpack_require__(49981);
// EXTERNAL MODULE: ./node_modules/react-hot-toast/dist/index.mjs + 1 modules
var dist = __webpack_require__(86501);
// EXTERNAL MODULE: ./graphql/events/getPremiumEventsByOrganisationUrl.ts
var getPremiumEventsByOrganisationUrl = __webpack_require__(99261);
;// CONCATENATED MODULE: ./pages/dashboard.tsx
































function OrganizerLaunchPage() {
    var ref, ref1;
    const { profile  } = (0,useAuth/* useAuth */.aC)();
    const { theme , setTheme  } = (0,useTheme/* useTheme */.Fg)();
    const uploadFile = (0,useFileUploader/* default */.Z)();
    const [updateOrganisation] = (0,useMutation/* useMutation */.D)(organisation_updateOrganisation/* UPDATE_ORGANISATION */.$);
    const [organisationBanner, setOrganisationBanner] = (0,react.useState)();
    const [sectionTitle, setSectionTitle] = (0,react.useState)("Online");
    const [isReady, setIsReady] = (0,react.useState)(false);
    const [term, setTerm] = (0,react.useState)("");
    const [filterTypes, setFilterTypes] = (0,react.useState)([
        "ONLINE",
        "IN_PERSON",
        "FUNDRAISER"
    ]);
    const [pastCleaned, setPastCleaned] = (0,react.useState)([]);
    const [companyCleaned, setCompanyCleaned] = (0,react.useState)([]);
    const [myEventsCleaned, setMyEventsCleaned] = (0,react.useState)([]);
    const [premiumCleaned, setPremiumCleaned] = (0,react.useState)([]);
    const isOrganizer = profile === null || profile === void 0 ? void 0 : (ref = profile.groups) === null || ref === void 0 ? void 0 : ref.includes("organizer");
    const isAdmin = profile === null || profile === void 0 ? void 0 : (ref1 = profile.groups) === null || ref1 === void 0 ? void 0 : ref1.includes("forumm-admin");
    (0,react.useEffect)(()=>{
        if (profile === null || profile === void 0 ? void 0 : profile.email) setIsReady(true);
    }, [
        profile
    ]);
    var ref2, ref3;
    const company = (0,react.useMemo)(()=>{
        return (ref3 = (ref2 = profile === null || profile === void 0 ? void 0 : profile.university) !== null && ref2 !== void 0 ? ref2 : profile === null || profile === void 0 ? void 0 : profile.company) !== null && ref3 !== void 0 ? ref3 : "";
    }, [
        profile
    ]);
    const { loading: myEventsLoading , data  } = (0,useLSFirst/* default */.Z)("my-events", GET_MY_EVENT_OVERVIEWS, {});
    const { loading: adminLoading , data: adminData  } = (0,useLSFirst/* default */.Z)("all-events", GET_ALL_EVENT_OVERVIEWS, {
        skip: !isAdmin
    });
    const { loading: pastEventsLoading , data: pastEventsData  } = (0,useLSFirst/* default */.Z)("past-events", GET_PAST_EVENTS, {});
    const { loading: premiumLoading , data: premiumData  } = (0,useLSFirst/* default */.Z)("premium-events", getPremiumEventsByOrganisationUrl/* GET_PREMIUM_EVENTS_BY_ORGANISATION */.mx, {});
    (0,react.useEffect)(()=>{
        if (profile) {
            console.log("Profile: ", profile === null || profile === void 0 ? void 0 : profile.email, "\nCompany: ", company);
        }
    }, [
        profile
    ]);
    const { loading: companyLoading , data: companyData  } = (0,useLSFirst/* default */.Z)("company-overview-events", getEventsByCompanyOverviews/* GET_EVENTS_BY_COMPANY_OVERVIEWS */.j, {
        variables: {
            company
        },
        skip: !company
    });
    (0,react.useEffect)(()=>{
        if (!companyLoading && !pastEventsLoading && profile) {
            const companyEvents = (companyData === null || companyData === void 0 ? void 0 : companyData.getEventsByCompany) || [];
            const pastEvents = (pastEventsData === null || pastEventsData === void 0 ? void 0 : pastEventsData.getPastEvents) || [];
            console.log("Company Current Events (".concat(companyEvents.length, ")"));
            console.log("Company Past Events (".concat(pastEvents.length, ")"));
        }
    }, [
        companyLoading,
        companyData,
        pastEventsLoading,
        pastEventsData,
        profile
    ]);
    const { loading: organisationLoading , profile: organisationData , ready: organisationReady , refetchOrganisation  } = (0,useOrganisationProfile/* useOrganisationProfile */.k)(company);
    let events = data === null || data === void 0 ? void 0 : data.getMyEvents;
    if (isAdmin) events = adminData === null || adminData === void 0 ? void 0 : adminData.getAllPublicEvents;
    const companyEvents = companyData === null || companyData === void 0 ? void 0 : companyData.getEventsByCompany;
    const pastEvents = pastEventsData === null || pastEventsData === void 0 ? void 0 : pastEventsData.getPastEvents;
    const premiumEvents = premiumData === null || premiumData === void 0 ? void 0 : premiumData.getPremiumEventsByOrganisation;
    const filterEventsByType = function(events, allowedTypes) {
        let allowPremium = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
        return events === null || events === void 0 ? void 0 : events.filter((eventItem)=>{
            var ref;
            if (eventItem.isPremium && !allowPremium) return false;
            var ref1;
            return allowedTypes === null || allowedTypes === void 0 ? void 0 : allowedTypes.includes((ref1 = eventItem === null || eventItem === void 0 ? void 0 : (ref = eventItem.event) === null || ref === void 0 ? void 0 : ref.eventType) !== null && ref1 !== void 0 ? ref1 : "");
        });
    };
    (0,react.useEffect)(()=>{
        if (filterTypes) {
            let pastClean, companyClean, myEventClean, premiumClean;
            if (pastEvents) {
                pastClean = filterEventsByType(pastEvents, filterTypes, true);
                setPastCleaned(pastClean);
            }
            if (premiumData) {
                premiumClean = filterEventsByType(premiumEvents, filterTypes, true);
                setPremiumCleaned(premiumClean);
            }
            if (companyEvents) {
                companyClean = filterEventsByType(companyEvents, filterTypes);
                setCompanyCleaned(companyClean);
            }
            if (events) {
                myEventClean = filterEventsByType(events, filterTypes);
                console.log("User Events (".concat(myEventClean === null || myEventClean === void 0 ? void 0 : myEventClean.length, ")"));
                setMyEventsCleaned(myEventClean);
            }
        }
    }, [
        filterTypes,
        pastEvents,
        companyEvents,
        events,
        premiumEvents
    ]);
    const handleTitle = (value)=>{
        setSectionTitle(value);
    };
    const router = (0,next_router.useRouter)();
    const slideIn = {
        hidden: {
            opacity: 0,
            x: "-100vw"
        },
        visible: {
            opacity: 1,
            x: 0
        }
    };
    const returnTitle = (value)=>{
        switch(value){
            case "ONLINE":
                return "Online";
            case "IN_PERSON":
                return "In-Person";
            case "FUNDRAISER":
                return "Donation";
            default:
                return "";
        }
    };
    // NOTE: Handles the toast popup when a user completes the signup to login flow.
    (0,react.useEffect)(()=>{
        const existingLogin = new URLSearchParams(document.location.search).has("existinglogin");
        if (existingLogin && isReady) {
            (0,dist/* default */.ZP)("Logged in to your exisiting account, using the provided credentials.", {
                icon: "\uD83D\uDCAC",
                duration: 8000
            });
        }
    }, [
        isReady
    ]);
    (0,react.useEffect)(()=>{
        if (filterTypes.length === 0 || filterTypes.length === 3) {
            setSectionTitle("".concat(company, "'s"));
        }
        if (filterTypes.length === 1) {
            setSectionTitle("".concat(company, "'s ").concat(returnTitle(filterTypes[0])));
        }
        if (filterTypes.length === 2) {
            setSectionTitle("".concat(company, "'s ").concat(returnTitle(filterTypes[0]), " and ").concat(returnTitle(filterTypes[1])));
        }
    }, [
        filterTypes,
        company
    ]);
    const handleUpdateOrganisation = async (param)=>{
        let { bannerImage , headerTextOne , headerTextTwo  } = param;
        var ref;
        const companyName = (ref = organisationData === null || organisationData === void 0 ? void 0 : organisationData.name) !== null && ref !== void 0 ? ref : profile === null || profile === void 0 ? void 0 : profile.company;
        if (companyName) {
            let variables = {
                name: companyName
            };
            if (bannerImage) variables.bannerImage = bannerImage;
            if (headerTextOne) variables.headerTextOne = headerTextOne;
            if (headerTextTwo) variables.headerTextTwo = headerTextTwo;
            await updateOrganisation({
                variables
            });
            setTimeout(()=>{
                refetchOrganisation();
            }, 500);
        }
    };
    var ref4;
    const headerBanner = (ref4 = organisationBanner !== null && organisationBanner !== void 0 ? organisationBanner : organisationData === null || organisationData === void 0 ? void 0 : organisationData.bannerImage) !== null && ref4 !== void 0 ? ref4 : header_background/* default.src */.Z.src;
    if (!profile) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingBar/* default */.Z, {});
    }
    if (!isReady || organisationLoading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
            className: "flex-1 overflow-y-scroll h-[calc(100vh)] relative flex items-center flex-col",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingBar/* default */.Z, {})
        });
    }
    const isDarkTheme = theme.type === "DARK";
    const headerTitle = (organisationData === null || organisationData === void 0 ? void 0 : organisationData.headerTextOne) ? organisationData === null || organisationData === void 0 ? void 0 : organisationData.headerTextOne : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            "Welcome to your ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            company,
            " Space"
        ]
    });
    const headerSubTitle = (organisationData === null || organisationData === void 0 ? void 0 : organisationData.headerTextTwo) ? organisationData === null || organisationData === void 0 ? void 0 : organisationData.headerTextTwo : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            "Here, you",
            "'",
            "ll discover all the events and donation initiatives vital to our community. Lovingly created by the",
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "/",
                className: " underline",
                style: {
                    color: theme.highlightColour
                },
                children: "Forumm Team"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            "If you spot any gremlins along the way, please don",
            "'",
            "t hesitate to let us know."
        ]
    });
    const totalAccountEvents = (events !== null && events !== void 0 ? events : []).length + (companyEvents !== null && companyEvents !== void 0 ? companyEvents : []).length;
    const myEventsEmpty = !myEventsLoading && myEventsCleaned.length === 0;
    // Sets the theme back to Forumm's when on the dashboard.
    if (!!theme && !!theme.organisationName && theme.organisationName !== "Forumm") setTheme({
        ...theme,
        organisationName: "Forumm"
    });
    var ref5, _company;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
        className: "flex flex-1 -mt-[80px] pt-[80px] overflow-y-scroll overflow-x-hidden h-[calc(100vh)] items-center flex-col relative",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                className: "relative sm:flex justify-center w-full md:min-h-[25rem]",
                style: {
                    backgroundImage: "url(".concat(headerBanner, ")"),
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                    backgroundColor: theme.backgroundColour
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                    className: "lg:min-w-[57rem] z-999 relative w-full flex justify-center items-center ",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                            show: isOrganizer,
                            className: "absolute cursor-pointer top-5 right-5 z-10",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FileInput/* FileInput */.S, {
                                uploadFile: uploadFile,
                                crop: true,
                                cropAspectRatio: 4,
                                cropShape: "rect",
                                value: organisationBanner,
                                onChange: (data)=>{
                                    setOrganisationBanner(data);
                                    if (typeof data === "string" && data.length > 0) {
                                        handleUpdateOrganisation({
                                            bannerImage: data
                                        });
                                    }
                                },
                                minified: true
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                            className: "rounded-2xl shadow-lg md:w-[85%] max-w-[1500px] flex p-10 md:p-6 md:px-8 md:py-4 md:pt-6 md:pb-6 z-1000 animate-text-focus-in ".concat(isDarkTheme ? "" : "border border-forumm-menu-border"),
                            color: "backgroundColorBanner",
                            style: {
                                background: isDarkTheme ? "rgba(0, 0, 0, 0.7)" : "rgba(255, 255, 255, 0.6)",
                                backdropFilter: "blur(5px)",
                                WebkitBackdropFilter: "blur(5px)"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                className: "px-6 lg:px-0 z-1000 relative w-full",
                                children: [
                                    isOrganizer && /*#__PURE__*/ (0,jsx_runtime.jsx)(inputs_OrganizationBannerEditPopup, {
                                        headerTextOne: organisationData === null || organisationData === void 0 ? void 0 : organisationData.headerTextOne,
                                        headerTextTwo: organisationData === null || organisationData === void 0 ? void 0 : organisationData.headerTextTwo,
                                        onSave: (headerTextOne, headerTextTwo)=>{
                                            handleUpdateOrganisation({
                                                headerTextOne,
                                                headerTextTwo
                                            });
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        className: "text-4xl font-medium pb-4 text-center leading-snug mt-2 px-12 sm:px-0 mb-2",
                                        children: headerTitle
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            className: "text-base text-center px-12 sm:px-6 animate-text-focus-in",
                                            children: headerSubTitle
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                        className: "flex justify-center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                            className: "mt-4",
                                            title: "Create Event",
                                            onClick: ()=>router.push("/create-event")
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                className: "pl-12 mt-6 sm:pl-0 sm:flex sm:flex-row-reverse justify-between md:w-[85%] max-w-[1500px] px-3 sm:p-0 ",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                        className: "my-2 sm:my-0 ml-2 sm:ml-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dashboard_SearchEvent, {
                            searchTerm: term,
                            setSearchTerm: (inputText)=>setTerm(inputText)
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                        className: "flex gap-3 items-center mt-6 sm:mt-0 flex-wrap pl-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dashboard_FilterButton, {
                                buttonType: "ONLINE",
                                setTitle: handleTitle,
                                title: "Online Events",
                                types: filterTypes,
                                setTypes: (value)=>setFilterTypes(value)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dashboard_FilterButton, {
                                buttonType: "IN_PERSON",
                                setTitle: handleTitle,
                                title: "In-person Events",
                                types: filterTypes,
                                setTypes: (value)=>setFilterTypes(value)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dashboard_FilterButton, {
                                buttonType: "FUNDRAISER",
                                setTitle: handleTitle,
                                title: "Donations",
                                types: filterTypes,
                                setTypes: (value)=>setFilterTypes(value)
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                className: "pl-10 sm:pl-0 sm:flex sm:flex-row-reverse justify-between md:w-[85%] max-w-[1500px] px-3 sm:p-0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                    className: "text-white p-2 py-6 pt-0 w-full",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                    className: "text-2xl font-medium -mb-2 my-2 mt-16 pl-5 sm:pl-0 flex items-center space-x-2",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: "My Upcoming Events"
                                        }),
                                        myEventsLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                            className: "animate-spin inline-flex rounded-full h-[14px] w-[14px] border-2 mt-1 ml-2",
                                            style: {
                                                borderTopColor: "rgb(24, 26, 32)"
                                            }
                                        })
                                    ]
                                }),
                                myEventsCleaned && myEventsCleaned.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(EventsView/* default */.Z, {
                                            events: myEventsCleaned,
                                            types: filterTypes,
                                            title: term,
                                            currency: organisationData.currency
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(GoogleAdsManager/* GoogleAds */.M, {
                                            show: (0,register_util/* getOrganisationConfig */.RC)(register_util/* CONFIG_OPTIONS.SHOW_GOOGLE_ADS */.ce.SHOW_GOOGLE_ADS, (ref5 = profile === null || profile === void 0 ? void 0 : profile.company) !== null && ref5 !== void 0 ? ref5 : profile === null || profile === void 0 ? void 0 : profile.university),
                                            type: "horizontal"
                                        })
                                    ]
                                }),
                                myEventsEmpty && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    className: "pt-20 pb-20 text-base text-center",
                                    children: "No events are currently available. Please check back later!"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                            className: "text-2xl font-medium -mb-2 mt-16 pl-5 sm:pl-0 ml-0",
                            children: [
                                "Premium Events",
                                premiumLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                    className: "animate-spin inline-flex rounded-full h-[14px] w-[14px] border-2 mt-1 ml-2",
                                    style: {
                                        borderTopColor: "rgb(24, 26, 32)"
                                    }
                                })
                            ]
                        }),
                        premiumCleaned && premiumCleaned.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(EventsView/* default */.Z, {
                            events: premiumCleaned,
                            types: filterTypes,
                            title: term,
                            currency: organisationData.currency
                        }),
                        !premiumLoading && (premiumCleaned === null || premiumCleaned === void 0 ? void 0 : premiumCleaned.length) === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            className: "pt-20 pb-20 text-base text-center",
                            children: "No events are currently available. Please check back later!"
                        }),
                        company && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                    className: "text-2xl font-medium mb-2 my-2 mt-16 pl-5 sm:pl-0 ",
                                    children: [
                                        sectionTitle,
                                        " Upcoming Events",
                                        companyLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                            className: "animate-spin inline-flex rounded-full h-[14px] w-[14px] border-2 mt-1 ml-2",
                                            style: {
                                                borderTopColor: "rgb(24, 26, 32)"
                                            }
                                        })
                                    ]
                                }),
                                companyCleaned && companyCleaned.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(EventsView/* default */.Z, {
                                    events: companyCleaned,
                                    types: filterTypes,
                                    title: term,
                                    currency: organisationData.currency
                                }),
                                !companyLoading && companyCleaned.length === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    className: "pt-20 pb-20 text-base text-center",
                                    children: "No events are currently available. Please check back later!"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                            className: "text-2xl font-medium -mb-2 mt-16 pl-5 sm:pl-0 ml-0",
                            children: [
                                "My Past Events",
                                pastEventsLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                    className: "animate-spin inline-flex rounded-full h-[14px] w-[14px] border-2 mt-1 ml-2",
                                    style: {
                                        borderTopColor: "rgb(24, 26, 32)"
                                    }
                                })
                            ]
                        }),
                        pastCleaned && pastCleaned.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(EventsView/* default */.Z, {
                            events: pastCleaned,
                            types: filterTypes,
                            title: term,
                            currency: organisationData.currency
                        }),
                        !pastEventsLoading && pastCleaned.length === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            className: "pt-20 pb-20 text-base text-center",
                            children: "No events are currently available. Please check back later!"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                            className: "text-2xl font-medium -mb-2 mt-16 pl-5 sm:pl-0 ml-0",
                            children: [
                                "".concat(sectionTitle, " Past Events"),
                                pastEventsLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                    className: "animate-spin inline-flex rounded-full h-[14px] w-[14px] border-2 mt-1 ml-2",
                                    style: {
                                        borderTopColor: "rgb(24, 26, 32)"
                                    }
                                })
                            ]
                        }),
                        pastCleaned && pastCleaned.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(EventsView/* default */.Z, {
                            events: pastCleaned.filter((f)=>{
                                var ref, ref1;
                                return ((ref = f.event) === null || ref === void 0 ? void 0 : ref.organizationName.toUpperCase()) === ((ref1 = (_company = profile.company) !== null && _company !== void 0 ? _company : profile.university) === null || ref1 === void 0 ? void 0 : ref1.toUpperCase());
                            }),
                            types: filterTypes,
                            title: term,
                            currency: organisationData.currency
                        }),
                        !pastEventsLoading && pastCleaned.length === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            className: "pt-20 pb-20 text-base text-center",
                            children: "No events are currently available. Please check back later!"
                        })
                    ]
                })
            }),
            isReady && !organisationLoading && !myEventsLoading && !companyLoading && !pastEventsLoading && totalAccountEvents === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                    type: "secondary",
                    size: "large",
                    title: "Create your first event",
                    className: "mt-10 mb-20",
                    onClick: ()=>router.push("/create-event")
                })
            }),
            isOrganizer && !organisationLoading && organisationReady && /*#__PURE__*/ (0,jsx_runtime.jsx)(dashboard_StylingModal, {
                organisationData: organisationData
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterUnauthenticated/* default */.Z, {
                transparent: false
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Toaster */.x7, {
                toastOptions: {
                    className: "shadow-lg !rounded-full flex items-center border-2 !bg-forumm-white border-forumm-green !text-forumm-green mt-[80px]",
                    duration: 4000
                }
            })
        ]
    });
}
OrganizerLaunchPage.Layout = layouts_DashboardLayout;


/***/ })

}]);